import React, { createContext, useContext, useState } from 'react';
import { MenuChatContextProviderProps, MenuChatContextType } from './interface';

export const MenuChatContext = createContext({} as MenuChatContextType);

export function MenuChatContextProvider(props: MenuChatContextProviderProps) {
  const { children } = props;

  const [nutritionist, setNutritionist] = useState<string>("");

  return (
    <MenuChatContext.Provider value={{
      nutritionist,
      setNutritionist: (name) => setNutritionist(name),
    }}>
      {children}
    </MenuChatContext.Provider>
  );
}

export const useMenuChatContext = () => {
  return useContext(MenuChatContext);
};